// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZkaE","signatureBlock":"Footer_signatureBlock__3QHeT","signature":"Footer_signature__2t1Yr"};